// extracted by mini-css-extract-plugin
module.exports = {"container":"OrderDetailsPrintButton_container__rzrxY","text":"OrderDetailsPrintButton_text__1wEbX","text-ltr":"OrderDetailsPrintButton_text-ltr__vFMaR"};